module.exports = __webpack_public_path__ + "media/22.abfa64ac.mp3";